import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const CustomerInvoice = ({ fields, invoiceStatusList }) => {
  const cancelledStatus = invoiceStatusList
    ? invoiceStatusList.find((s) => s.code === 'CANCELLED')
    : null;

  const paidStatus = invoiceStatusList
    ? invoiceStatusList.find((s) => s.code === 'PAID')
    : null;

  const currentStatusId =
    fields && fields.customerInvoiceStatusId
      ? fields.customerInvoiceStatusId
      : null;

  const isPaid = paidStatus && currentStatusId === paidStatus.id;

  // Filter options: show current status + CANCELLED (only if not PAID)
  let statusOptions = [];
  if (invoiceStatusList && cancelledStatus) {
    statusOptions = invoiceStatusList
      .filter(
        (s) =>
          s.id === currentStatusId ||
          (s.id === cancelledStatus.id && !isPaid)
      )
      .map((s) => ({ ...s, name: s.code }));
  }

  const isCancelled =
    cancelledStatus && currentStatusId === cancelledStatus.id;

  return [
    {
      name: 'invoiceStampingNumber',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value: '001-002',
      options: [{ id: '001-002', name: '001-002' }],
      readonly: true
    },
    {
      name: 'invoiceNumber',
      validation: yup
        .number()
        .typeError('fieldNumeric')
        .required('fieldRequired'),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.number ? fields.number : '',
      readonly: true
    },
    {
      name: 'customerInvoiceStatusId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value: currentStatusId || '',
      options: statusOptions,
      readonly: isCancelled ? true : false,
      enabled: fields && fields.id
    },
    {
      name: 'scheduledPaymentDate',
      validation: yup.date().when('customerInvoiceStatusId', {
        is: (statusId) => cancelledStatus && statusId === cancelledStatus.id,
        then: yup.date().nullable(true),
        otherwise: yup.date().required('fieldRequired')
      }),
      type: FormFieldType.DATETIME,
      value:
        fields && fields.scheduledPaymentDate
          ? fields.scheduledPaymentDate
          : null
    },
    {
      name: 'comments',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_AREA,
      value: fields && fields.comments ? fields.comments : '',
      fullWidth: true,
      readonly: true
    },
    {
      name: 'newComment',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.TEXT_AREA,
      value: fields && fields.newComment ? fields.newComment : '',
      fullWidth: true
    }
  ];
};

export default CustomerInvoice;
